import React, { useState } from "react";

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24">
    <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.9 21 3 13.1 3 3.9c0-.6.4-1 1-1h3.2c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.4 0 .8-.2 1L6.6 10.8z" />
  </svg>
);

const navItems = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Contact Us", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header>
      <div className="nav">
        <div className="brand">
          <img src="/assets/logo.png" alt="Compassionate Senior Placement LLC logo" />
          <div className="brand-text">
            <b>Compassionate Senior Placement</b>
            <span>askhemo.com</span>
          </div>
        </div>
        <nav className="nav-links">
          {navItems.map((item) => (
            <a key={item.href} href={item.href}>{item.label}</a>
          ))}
        </nav>
        <div className="nav-cta">
          <a className="nav-phone" href="tel:9547080298">
            <PhoneIcon />
            954-708-0298
          </a>
          <a className="btn" href="#contact">Get in Touch</a>
        </div>
        <button
          className={`nav-toggle${open ? " is-open" : ""}`}
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          <span></span><span></span><span></span>
        </button>
      </div>
      <nav className={`nav-links-mobile${open ? " open" : ""}`}>
        {navItems.map((item) => (
          <a key={item.href} href={item.href} onClick={() => setOpen(false)}>{item.label}</a>
        ))}
      </nav>
    </header>
  );
}
